import { create } from 'zustand';
import { getIframeModeParams } from '@/utils/iframeMode';

interface IframeModeState {
  isIframeMode: boolean;
  os: string;
  customerId: string;
  hasRecommendation: boolean;
  hasPersonalizedSupplementRecommendations: boolean;
  isEligibleForSupplements: boolean;
  subscriptionId: number | null;
  setIframeMode: (params: {
    isIframeMode: boolean;
    customerId: string;
    hasRecommendation: boolean;
    hasPersonalizedSupplementRecommendations: boolean;
    isEligibleForSupplements: boolean;
    subscriptionId: number | null;
  }) => void;
}

const initialParams = getIframeModeParams();

export const useIframeModeStore = create<IframeModeState>((set) => ({
  isIframeMode: initialParams.isIframeMode,
  os: initialParams.os,
  customerId: initialParams.customerId || '',
  hasRecommendation: initialParams.hasRecommendation,
  hasPersonalizedSupplementRecommendations: initialParams.hasPersonalizedSupplementRecommendations,
  isEligibleForSupplements: initialParams.isEligibleForSupplements,
  subscriptionId: initialParams.subscriptionId,
  setIframeMode: (params) => set(params),
}));
